import { IItemList } from '../model'

export enum ActionType {
  POST_CONNECT_PRODUCT = 'POST_CONNECT_PRODUCT',
  GET_PRODUCT_LIST = 'GET_PRODUCT_LIST',
  SET_PRODUCT_LIST = 'SET_PRODUCT_LIST',
  SET_PREVIEW_PRODUCT = 'SET_PREVIEW_PRODUCT',
  GET_PRODUCT = 'GET_PRODUCT',
  SET_PRODUCT = 'SET_PRODUCT',
  GET_PRODUCT_NEW = 'GET_PRODUCT_NEW',
  SET_PRODUCT_NEW = 'SET_PRODUCT_NEW',
}

export const PAGE_SIZE_PRODUCT_LIST = 300

export interface IGetProduct {
  id: number | string
  type?: string
}

export interface IPostConnectProduct {
  clientId: number | null
  productId: number
}

export interface ISetProduct {
  type: string
  data: IItemList<IProduct>
}

export interface IMedia {
  type: string
  url: string
  name: string
  originalFileName: string
  error?: string
}

export interface IProductForm {
  name: string
  typeId: string | number
  vendor: string
  link: string
  logo: any
  media: IMedia[]
  newMedia: any
  shortDescription: string
  description: string
  functions?: string
  isMadeInRus?: boolean
  isNew?: boolean
  status: 'published' | 'not-published'
  pseudoComponent?: JSX.Element
  budgetMode: string
  budgetDescription: string
}

export interface IPreviewProduct extends IProductForm {
  id?: number
  isEdit: boolean
}

export interface IPatchProductForm {
  id: string
  data: IProductForm
}

interface IProductClient {
  id: number
  name: string
  logo: string
}

export interface IProduct extends IProductForm {
  // pseudoComponent - решение для карточки консультации в локальных продуктах, сделано т.к. необходимо
  // было внести в список продуктов (компонент CardList) данную карту
  id: number
  isConnected: boolean
  clients: IProductClient[]
  typeName: string
}

export interface IProductRequest {
  description: string
}
